/* Climat72 · поведение страниц категории, сравнения, списка, запроса сметы и оглавление текстовых страниц. Собрано из design\src (_pages.js, _prose.js, _faq.js). Править там, затем: python src\export_shopify.py */
/* Поведение страниц каталога, сравнения, списка для сметы и запроса сметы в макете. Без библиотек.
   В теме Shopify: assets/c72-pages-ui.js. Обработчики фильтров, сравнения, списка и проверки формы там заменяются модулями logic\
   (c72-filters.js, c72-compare.js, c72-quote-list.js, c72-form.js); разметка и атрибуты data-* при этом не меняются.
   Всё привязано к data-*, не к классам. Каждая часть молчит, если её корня на странице нет.
   Скрипт подключён на всех страницах темы, поэтому не мешает настоящим страницам Shopify:
   * фильтры и сортировка работают в браузере, только если у карточек есть данные (data-brand, data-btu: макет); в теме фильтры
     отправляет своя форма Shopify, сортировка уходит параметром sort_by, товары скрипт не прячет;
   * настоящая форма Shopify (есть action и скрытое поле form_type) после проверки отправляется обычным образом;
   * счётчик без window.c72T берёт формы слова из data-count-one / data-count-other (их выводит тема), иначе оставляет текст сервера. */
(function () {
  var root = document.documentElement;
  var $ = function (sel, scope) { return (scope || document).querySelector(sel); };
  var all = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
  var each = function (sel, fn, scope) { all(sel, scope).forEach(fn); };
  var fire = function (name) { document.dispatchEvent(new CustomEvent(name)); };
  var isEn = function () { return String(root.lang).slice(0, 2) === 'en'; };
  var shown = function (el) { return !!el && !el.closest('[hidden]'); };

  /* Фокус на элемент, который сам его не принимает (заголовок, блок пустого состояния) */
  function focusSoft(el) {
    if (!el) return;
    if (!el.matches('a[href],button,input,select,textarea,summary,[tabindex]')) el.setAttribute('tabindex', '-1');
    el.focus();
  }

  /* Текст элемента на одном языке: в макете в элементе лежат оба языка, в теме язык один */
  function textIn(el, lang) {
    var copy = el.cloneNode(true);
    each('[lang]', function (part) { if (part.lang !== lang) part.remove(); }, copy);
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  /* --- Счётчики с множественным числом. В макете в разметке лежат обе формы слова на двух языках (из @count).
         В теме в элементе готовая строка: её обновляет переводчик window.c72T(ключ, { count }) (createTranslator из logic\c72-i18n.js),
         а без него — формы из data-count-one / data-count-other с подстановкой __COUNT__. Если нет ни того, ни другого, текст сервера остаётся. --- */
  function setCount(scope, n) {
    if (!scope) return;
    var boxes = scope.matches && scope.matches('[data-count-key]') ? [scope] : all('[data-count-key]', scope);
    boxes.forEach(function (box) {
      if (!$('[data-count]', box)) {
        var form = box.getAttribute((isEn() ? n === 1 : n < 2) ? 'data-count-one' : 'data-count-other');
        if (typeof window.c72T === 'function') box.textContent = window.c72T(box.getAttribute('data-count-key'), { count: n });
        else if (form !== null) box.textContent = form.replace(/__COUNT__/g, String(n));
        return;
      }
      each('[data-count]', function (e) { e.textContent = String(n); }, box);
      each('[lang]', function (part) {
        var one = part.lang === 'fr' ? n < 2 : n === 1;     // французский: 0 и 1 в единственном числе
        each('[data-one]', function (e) { e.hidden = !one; }, part);
        each('[data-many]', function (e) { e.hidden = one; }, part);
      }, box);
    });
  }

  /* --- Всплывающее уведомление: одно за раз, тексты лежат в <template data-toast>. Исчезает через 6 с;
         пока на нём указатель или фокус (кнопка «Annuler»), отсчёт стоит (WCAG 2.2.1). --- */
  var toastTimer = 0;
  function toast(name, onUndo) {
    var host = $('[data-toasts]'), tpl = $('template[data-toast="' + name + '"]');
    if (!host || !tpl) return;
    host.textContent = '';
    var node = tpl.content.firstElementChild.cloneNode(true);
    host.appendChild(node);
    var arm = function () {
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { if (node.parentNode) node.remove(); }, 6000);
    };
    var resume = function () {
      if (node.isConnected && !node.matches(':hover') && !node.contains(document.activeElement)) arm();
    };
    node.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
    node.addEventListener('focusin', function () { clearTimeout(toastTimer); });
    node.addEventListener('mouseleave', resume);
    node.addEventListener('focusout', function () { setTimeout(resume, 0); });
    var undo = $('[data-undo]', node);
    if (undo) undo.addEventListener('click', function () { clearTimeout(toastTimer); host.textContent = ''; if (onUndo) onUndo(); });
    arm();
  }

  /* --- Выдвижная панель: открыть, закрыть, удержать фокус внутри --- */
  var opener = null;
  function drawer(panel, open) {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    each('[data-backdrop]', function (b) { b.classList.toggle('is-open', open); });
    each('[data-drawer-open="' + panel.getAttribute('data-drawer') + '"]', function (b) { b.setAttribute('aria-expanded', String(open)); });
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      var first = $('[data-drawer-close]', panel);
      if (first) first.focus();
    } else {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      if (opener) opener.focus();
    }
  }
  window.addEventListener('resize', function () {          // на широком экране панель лежит в потоке страницы: открытую закрываем
    var panel = $('[data-drawer].is-open');
    if (panel && window.innerWidth > 940) drawer(panel, false);
  });
  document.addEventListener('keydown', function (ev) {
    var panel = $('[data-drawer].is-open');
    if (!panel) return;
    if (ev.key === 'Escape') { drawer(panel, false); return; }
    if (ev.key !== 'Tab') return;
    var stops = all('a[href],button,input,select,textarea,summary', panel).filter(function (e) { return e.offsetParent !== null && !e.disabled; });
    if (!stops.length) return;
    var first = stops[0], last = stops[stops.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  });

  /* ================= Каталог: фильтры, сортировка, выбранные фильтры, пустой результат ================= */
  var cat = $('[data-catalog]');
  var applyFilters = function () {};
  if (cat) {
    var filters = $('[data-filters]', cat), grid = $('[data-grid]', cat);
    var cards = all('[data-item]', grid), initial = cards.slice();
    // В макете у карточек есть данные для фильтров; в теме их нет: товары отбирает Shopify (форма фильтров, параметр sort_by)
    var local = cards.length > 0 && cards.every(function (el) { return el.hasAttribute('data-brand') && el.hasAttribute('data-btu'); });
    var sendable = !!filters.getAttribute('action');            // настоящая форма фильтров темы (collection.filters)
    var num = function (el, key) { return Number(el.getAttribute('data-' + key)); };
    var parts = function (el, key) { return (el.getAttribute('data-' + key) || '').split(','); };
    var picked = function (name) { return all('input[name="' + name + '"]:checked', filters).map(function (i) { return i.value; }).filter(Boolean); };
    var send = function () { if (filters.requestSubmit) filters.requestSubmit(); else filters.submit(); };

    var matches = function (el) {
      var brands = picked('brand'), sizes = picked('btu'), gases = picked('refrigerant');
      var seer = Number(picked('seer2_min')[0] || 0), temp = picked('min_temp_max')[0], sound = Number(picked('indoor_db_max')[0] || 0);
      if (brands.length && brands.indexOf(el.getAttribute('data-brand')) < 0) return false;
      if (sizes.length && !sizes.some(function (s) { return parts(el, 'btu').indexOf(s) >= 0; })) return false;
      if (gases.length && gases.indexOf(el.getAttribute('data-refrigerant')) < 0) return false;
      if (seer && num(el, 'seer2') < seer) return false;
      if (temp && num(el, 'min-temp') > Number(temp)) return false;
      if (sound && num(el, 'db-in') > sound) return false;
      if (picked('wifi').length && el.getAttribute('data-wifi') !== '1') return false;
      if (picked('energy_star').length && el.getAttribute('data-energy-star') !== '1') return false;
      return true;
    };

    var clearAll = function () {                                  // все флажки сняты, у переключателей выбран пункт «любой»
      each('input[type="checkbox"]', function (i) { i.checked = false; }, filters);
      each('input[type="radio"][value=""]', function (i) { i.checked = true; }, filters);
    };

    var chips = function () {
      var host = $('[data-active-list]', cat), active = all('input:checked', filters).filter(function (i) { return i.value !== ''; });
      host.textContent = '';
      active.forEach(function (input) {
        var label = $('[data-label]', input.parentNode), suffix = input.getAttribute('data-suffix') || '';
        if (!label) return;
        var li = document.createElement('li'), btn = document.createElement('button'), text = document.createElement('span');
        btn.type = 'button';
        btn.className = 'c72-x';
        text.className = 'c72-x__t';
        text.innerHTML = label.innerHTML;
        if (suffix) text.appendChild(document.createTextNode(suffix));
        btn.appendChild(text);
        btn.insertAdjacentHTML('beforeend', '<svg class="c72-ic" viewBox="0 0 24 24" aria-hidden="true"><use href="#ic-close"/></svg>');
        ['fr', 'en'].forEach(function (lang) { btn.setAttribute('data-al-' + lang, (host.getAttribute('data-remove-' + lang) || host.getAttribute('data-remove-label') || '').trim() + ' ' + textIn(label, lang) + suffix); });
        btn.setAttribute('aria-label', btn.getAttribute('data-al-' + (isEn() ? 'en' : 'fr')));
        btn.addEventListener('click', function () {
          var at = all('button', host).indexOf(btn);
          if (input.type === 'radio') { var any = $('input[name="' + input.name + '"][value=""]', filters); if (any) any.checked = true; else input.checked = false; }
          else input.checked = false;
          if (!local) { if (sendable) { send(); return; } chips(); }
          else applyFilters();
          var rest = all('button', host);                         // фокус: на соседнюю плашку, без плашек — на счётчик найденного
          if (rest.length) rest[Math.min(at, rest.length - 1)].focus();
          else focusSoft($('[data-results]', cat));
        });
        li.appendChild(btn);
        host.appendChild(li);
      });
      $('[data-active]', cat).hidden = active.length === 0;
      each('[data-filter-count]', function (e) { e.textContent = String(active.length); e.hidden = active.length === 0; }, cat);
    };

    applyFilters = function () {
      if (!local) { chips(); return; }
      var shown = 0;
      cards.forEach(function (el) { var ok = matches(el); el.hidden = !ok; if (ok) shown++; });
      setCount($('[data-results]', cat), shown);
      grid.hidden = shown === 0;
      $('[data-empty]', cat).hidden = shown !== 0;
      chips();
    };

    var sortCards = function () {
      var mode = $('[data-sort]', cat).value;
      var low = function (el) { return Math.min.apply(null, parts(el, 'btu').map(Number)); };
      var high = function (el) { return Math.max.apply(null, parts(el, 'btu').map(Number)); };
      var name = function (el) { return el.getAttribute('data-name') || ''; };
      var rules = {
        name_asc: function (a, b) { return name(a).localeCompare(name(b)); },
        name_desc: function (a, b) { return name(b).localeCompare(name(a)); },
        capacity_asc: function (a, b) { return low(a) - low(b) || high(a) - high(b); },
        capacity_desc: function (a, b) { return high(b) - high(a) || low(b) - low(a); },
        seer2_desc: function (a, b) { return num(b, 'seer2') - num(a, 'seer2'); },
        cold_desc: function (a, b) { return num(b, 'h15') - num(a, 'h15'); },
        sound_asc: function (a, b) { return num(a, 'db-out') - num(b, 'db-out'); }
      };
      var sorted = rules[mode] ? initial.slice().sort(rules[mode]) : initial;
      sorted.forEach(function (el) { grid.appendChild(el); });
    };

    filters.addEventListener('change', function () {
      if (local) { applyFilters(); return; }
      if (sendable && !filters.closest('[data-drawer].is-open')) send();   // тема: на широком экране фильтр применяется сразу, в панели — кнопкой
      else chips();
    });
    filters.addEventListener('submit', function (ev) { if (local || !sendable) ev.preventDefault(); });
    $('[data-sort]', cat).addEventListener('change', function (ev) {
      if (local) { sortCards(); return; }
      var url = new URL(location.href);                       // тема: Shopify сортирует сам по параметру sort_by
      url.searchParams.set('sort_by', ev.target.value);
      url.searchParams.delete('page');
      location.href = url.toString();
    });
    cat.addEventListener('click', function (ev) {
      if (!ev.target.closest('[data-clear]')) return;
      ev.preventDefault();
      if (local) filters.reset(); else clearAll();
      if (!local && sendable) { send(); return; }
      applyFilters();
      var now = document.activeElement;                       // кнопка исчезла вместе с плашками или пустым результатом: фокус на счётчик найденного
      if (!now || now === document.body || !now.getClientRects().length) focusSoft($('[data-results]', cat));
    });
    applyFilters();
  }

  /* ================= Панель сравнения внизу страницы (каталог) ================= */
  var bar = $('[data-compare-bar]');
  var MAX_COMPARED = 3;
  function refreshBar() {
    if (!bar) return;
    var on = all('[data-compare][aria-pressed="true"]');
    bar.hidden = on.length === 0;
    each('[data-compare-count]', function (e) { e.textContent = String(on.length); }, bar);
    each('[data-compare-title]', function (e) { e.textContent = e.getAttribute('data-compare-title').replace('%c', String(on.length)); }, bar);   // в теме: заголовок по образцу из словаря
    var host = $('[data-compare-items]', bar);
    host.textContent = '';
    on.forEach(function (btn) {
      var card = btn.closest('[data-handle]'), title = card && $('[data-card-title]', card);
      if (!title) return;
      var li = document.createElement('li'), chip = document.createElement('button'), text = document.createElement('span');
      chip.type = 'button';
      chip.className = 'c72-x';
      text.className = 'c72-x__t';
      text.innerHTML = title.innerHTML;
      chip.appendChild(text);
      chip.insertAdjacentHTML('beforeend', '<svg class="c72-ic" viewBox="0 0 24 24" aria-hidden="true"><use href="#ic-close"/></svg>');
      ['fr', 'en'].forEach(function (lang) { chip.setAttribute('data-al-' + lang, (host.getAttribute('data-remove-' + lang) || host.getAttribute('data-remove-label') || '').replace('%s', textIn(title, lang))); });
      chip.setAttribute('aria-label', chip.getAttribute('data-al-' + (isEn() ? 'en' : 'fr')));
      chip.addEventListener('click', function () {
        var at = all('button', host).indexOf(chip);
        btn.setAttribute('aria-pressed', 'false');
        refreshBar();
        var rest = host.hidden ? [] : all('button', host);      // фокус: на соседнюю плашку, иначе на «очистить», иначе на кнопку «Comparer» карточки
        var next = rest[Math.min(at, rest.length - 1)] || (!bar.hidden && $('[data-compare-clear]', bar)) || btn;
        next.focus();
      });
      li.appendChild(chip);
      host.appendChild(li);
    });
    var enough = on.length >= 2;
    host.hidden = !enough;
    each('[data-compare-hint]', function (e) { e.hidden = enough; }, bar);
    each('[data-compare-go]', function (e) { e.setAttribute('aria-disabled', String(!enough)); }, bar);
    document.body.style.paddingBottom = bar.hidden ? '' : (bar.offsetHeight + 28) + 'px';   // панель не закрывает подвал
  }

  document.addEventListener('click', function (ev) {
    var open = ev.target.closest('[data-drawer-open]');
    if (open) { opener = open; drawer($('[data-drawer="' + open.getAttribute('data-drawer-open') + '"]'), true); return; }
    if (ev.target.closest('[data-drawer-close],[data-backdrop]')) { drawer($('[data-drawer].is-open'), false); return; }

    var compare = ev.target.closest('[data-compare]');
    if (compare && bar) {                                   // базовый скрипт уже переключил кнопку
      if (all('[data-compare][aria-pressed="true"]').length > MAX_COMPARED) { compare.setAttribute('aria-pressed', 'false'); toast('compare-full'); }
      refreshBar();
      return;
    }
    if (ev.target.closest('[data-compare-clear]')) { each('[data-compare]', function (b) { b.setAttribute('aria-pressed', 'false'); }); refreshBar(); return; }
    var go = ev.target.closest('[data-compare-go]');
    if (go && go.getAttribute('aria-disabled') === 'true') { ev.preventDefault(); return; }

    var add = ev.target.closest('[data-add]');
    if (add && $('[data-toasts]')) {
      if (add.getAttribute('aria-pressed') === 'true') toast('added');
      else toast('removed', function () { add.setAttribute('aria-pressed', 'true'); fire('c72:quote-list-change'); add.focus(); });
      return;
    }
    if (ev.target.closest('[data-copy-link]')) {
      try { navigator.clipboard.writeText(location.href).catch(function () {}); } catch (e) { /* буфер недоступен: в макете это не важно */ }
      toast('copied');
    }
  });
  document.addEventListener('c72:lang', refreshBar);
  refreshBar();

  /* ================= Страница сравнения: убрать модель, различия, полоса с названиями ================= */
  var cmp = $('[data-compare-page]');
  if (cmp) {
    var table = $('[data-compare-table]', cmp);
    var left = function () { return all('[data-compare-model]', table).filter(function (c) { return !c.hidden; }).length; };

    var rows = function () {
      var only = $('[data-compare-diff]', cmp).checked;
      each('[data-row]', function (tr) {
        var values = all('[data-col]', tr).filter(function (td) { return !td.hidden; }).map(function (td) { return td.textContent.replace(/\s+/g, ' ').trim(); });
        var differ = values.length > 1 && values.some(function (v) { return v !== values[0]; });
        tr.classList.toggle('is-diff', differ);
        tr.hidden = only && !differ;
      }, table);
      each('tbody', function (body) {
        var any = all('[data-row]', body).some(function (tr) { return !tr.hidden; });
        each('[data-group]', function (g) { g.hidden = !any; }, body);
      }, table);
    };

    var removeModel = function (id) {
      each('[data-col="' + id + '"]', function (c) { c.hidden = true; }, cmp);
      var n = left();
      each('[data-slot]', function (slot, i) { slot.hidden = i >= MAX_COMPARED - n; }, table);
      each('[data-compare-need]', function (e) { e.hidden = n !== 1; }, cmp);
      table.hidden = n === 0;
      each('[data-compare-empty]', function (e) { e.hidden = n !== 0; }, cmp);
      setCount(cmp, n);
      rows();
    };
    cmp.removeModel = removeModel;

    cmp.addEventListener('click', function (ev) {
      var x = ev.target.closest('[data-compare-remove]');
      if (!x) return;
      var ids = all('[data-compare-remove]', table).filter(shown).map(function (b) { return b.getAttribute('data-compare-remove'); });
      var id = x.getAttribute('data-compare-remove'), at = ids.indexOf(id);
      removeModel(id);
      var rest = ids.filter(function (i) { return i !== id; });  // фокус: на «убрать» соседней модели, без моделей — на сообщение «пусто»
      var next = rest[Math.min(at, rest.length - 1)];
      if (next) $('[data-compare-remove="' + next + '"]', table).focus();
      else focusSoft($('[data-compare-empty]', cmp));
    });
    $('[data-compare-diff]', cmp).addEventListener('change', rows);

    var stick = $('[data-compare-stick]', cmp), head = $('[data-compare-head]', cmp);
    var onScroll = function () {
      if (!stick || !head || table.hidden) return;
      var edge = parseFloat(getComputedStyle(root).getPropertyValue('--c72-hdr-h')) || 90;
      stick.classList.toggle('is-on', head.getBoundingClientRect().bottom < edge + 24 && table.getBoundingClientRect().bottom > edge + 160);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    rows();
    onScroll();
  }

  /* ================= Список для сметы: убрать, вернуть, очистить, пустой список ================= */
  var lst = $('[data-list-page]');
  if (lst) {
    var dialog = $('[data-dialog="clear"]', lst);
    var visibleItems = function () { return all('[data-list-item]', lst).filter(function (i) { return !i.hidden; }); };
    var emptyHeading = function () { var e = $('[data-list-empty]', lst); return e && (e.querySelector('h2,h3') || e); };
    var refreshList = function () {
      var n = visibleItems().length;
      setCount(lst, n);
      each('[data-list-body]', function (e) { e.hidden = n === 0; }, lst);
      each('[data-list-empty]', function (e) { e.hidden = n !== 0; }, lst);
      each('[data-list-dock]', function (e) { e.hidden = n === 0; }, lst);
      fire('c72:quote-list-change');
    };
    lst.refresh = refreshList;
    // Пока список не готов (нет data-list-ready), строки, пустое состояние и нижняя панель скрыты стилями: в теме атрибут ставит
    // модуль списка, когда прочитал хранилище (без мелькания «Votre liste est vide»). В макете строки-образцы (data-mock) есть сразу.
    if ($('[data-mock]', lst)) lst.setAttribute('data-list-ready', '');
    lst.addEventListener('click', function (ev) {
      var remove = ev.target.closest('[data-list-remove]');
      if (remove) {
        var item = remove.closest('[data-list-item]'), before = visibleItems(), at = before.indexOf(item);
        item.hidden = true;
        refreshList();
        var rest = before.filter(function (i) { return i !== item; });   // фокус: на «убрать» соседней строки, без строк — на заголовок пустого списка
        var next = rest[Math.min(at, rest.length - 1)];
        if (next) $('[data-list-remove]', next).focus();
        else focusSoft(emptyHeading());
        toast('removed', function () { item.hidden = false; refreshList(); $('[data-list-remove]', item).focus(); });
        return;
      }
      if (ev.target.closest('[data-list-clear]') && dialog) { if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); return; }
      if (ev.target.closest('[data-dialog-ok]')) {
        each('[data-list-item]', function (i) { i.hidden = true; }, lst);
        dialog.close();
        refreshList();
        focusSoft(emptyHeading());                                 // кнопка «Vider la liste» скрыта вместе со списком
        return;
      }
      if (ev.target.closest('[data-dialog-cancel]')) dialog.close();
    });
    refreshList();
  }

  /* ================= Запрос сметы и запись: проверка полей, сводка ошибок, отправка ================= */
  var form = $('[data-form]');
  if (form) {
    var kind = form.getAttribute('data-form');                                     // quote или service, как в logic\c72-form.js
    // Настоящая форма Shopify ({% form 'contact' %}): после проверки уходит обычной отправкой. В макете (action="#") — экран «отправлено».
    var real = !!form.getAttribute('action') && form.getAttribute('action') !== '#' && !!form.querySelector('input[name="form_type"]');
    var sending = false;
    var REQUIRED = kind === 'service' ? ['service', 'unitType', 'description', 'name', 'email', 'postalCode']   // FORMS.service.required
      : ['projectType', 'homeType', 'name', 'email', 'postalCode'];                                          // FORMS.quote.required
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var now = new Date(), today = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    var EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
    var POSTAL = /^([ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z])[ -]?(\d[ABCEGHJ-NPRSTV-Z]\d)$/;
    var controls = function (field) { return all('input,select,textarea', field); };
    var valueOf = function (field) {
      var list = controls(field);
      if (!list.length) return '';
      if (list[0].type === 'radio') { var on = list.filter(function (i) { return i.checked; })[0]; return on ? on.value : ''; }
      return String(list[0].value).replace(/\s+/g, ' ').trim();
    };

    /* Код ошибки поля или пустая строка; предупреждение не мешает отправке */
    var judge = function (name, value) {
      if (value === '') return { error: REQUIRED.indexOf(name) >= 0 ? 'required' : '' };
      if (name === 'email' && !EMAIL.test(value)) return { error: 'invalid' };
      if (name === 'phone') {
        var digits = value.replace(/[\s,;]*(?:ext\.?|poste|x|#)\s*\d{1,6}$/i, '').replace(/\D/g, '');   // добавочный номер допустим
        if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
        if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return { error: 'invalid' };
      }
      if (name === 'postalCode') {
        var code = POSTAL.exec(value.toUpperCase());
        if (!code) return { error: 'invalid' };
        if ('HJ'.indexOf(code[1][0]) < 0) return { error: '', warning: 'outOfArea' };
      }
      if (name === 'area' && !/^\d+([.,]\d+)?$/.test(value.replace(/\s/g, ''))) return { error: 'invalid' };
      if (name === 'date' && value < today) return { error: 'past' };                // желаемая дата не в прошлом
      return { error: '' };
    };

    var paint = function (field, quiet) {
      var name = field.getAttribute('data-field'), value = valueOf(field), verdict = judge(name, value);
      if (quiet && verdict.error === 'required') verdict.error = '';        // пустое обязательное поле краснеет только после отправки
      controls(field).forEach(function (c) { if (verdict.error) c.setAttribute('aria-invalid', 'true'); else c.removeAttribute('aria-invalid'); });
      each('[data-choices]', function (g) { if (verdict.error) g.setAttribute('aria-invalid', 'true'); else g.removeAttribute('aria-invalid'); }, field);
      each('[data-err]', function (e) { e.hidden = e.getAttribute('data-err') !== verdict.error; }, field);
      each('[data-warn]', function (e) { e.hidden = e.getAttribute('data-warn') !== verdict.warning; }, field);
      field.classList.toggle('is-ok', !verdict.error && value !== '' && controls(field)[0].type !== 'radio');
      return verdict.error;
    };

    var summary = $('[data-form-summary]', form);
    var reported = function () { return !!summary && !summary.hidden; };   // после экрана «отправлено» в теме полей и сводки нет
    var report = function () {
      var bad = all('[data-field]', form).filter(function (f) { return paint(f, false); });
      var listEl = $('[data-summary-list]', summary);
      listEl.textContent = '';
      bad.forEach(function (field) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + controls(field)[0].id;
        a.innerHTML = $('[data-err]:not([hidden]) [data-msg]', field).innerHTML;
        li.appendChild(a);
        listEl.appendChild(li);
      });
      setCount(summary, bad.length);
      summary.hidden = bad.length === 0;
      return bad;
    };

    var busy = function (on) {                                                 // «Envoi en cours…» и защита от второй отправки
      sending = on;
      each('[data-send-idle]', function (e) { e.hidden = on; }, form);
      each('[data-send-busy]', function (e) { e.hidden = !on; }, form);
      each('[type="submit"]', function (b) { if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); }, form);
    };

    form.addEventListener('focusout', function (ev) {
      var field = ev.target.closest('[data-field]');
      if (field) paint(field, !reported());
    });
    form.addEventListener('change', function (ev) {
      var field = ev.target.closest('[data-field]');
      if (!field) return;
      paint(field, !reported());
      if (field.getAttribute('data-field') === 'occupancy') {                    // по коду варианта: в теме value — подпись (её читает письмо)
        var on = $('input:checked', field);
        each('[data-tenant-help]', function (e) { e.hidden = !on || (on.getAttribute('data-code') || on.value) !== 'tenant'; }, form);
      }
      if (reported()) report();
    });
    form.addEventListener('submit', function (ev) {
      if (sending || !summary) { ev.preventDefault(); return; }               // повторный Enter или щелчок, пока заявка уходит
      var bad = report();
      if (bad.length) { ev.preventDefault(); summary.focus(); summary.scrollIntoView({ block: 'center' }); return; }
      busy(true);
      if (real) return;                                                        // тема: обычная отправка формы contact, страница перезагрузится
      ev.preventDefault();
      setTimeout(form.done, 700);                                              // макет: настоящей отправки нет
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted && sending) busy(false); });   // возврат «назад» из кэша браузера
    form.done = function () {
      var sent = all('[data-list-item]', form).filter(function (i) { return !i.hidden; }).length;
      var done = $('[data-form-success]', form);
      setCount(done, sent);
      each('[data-sent-some]', function (e) { e.hidden = sent === 0; }, done);
      var filled = 0;
      each('[data-sum]', function (slot) {                                            // сводка записи: выбранные значения на языке подписи
        var field = $('[data-field="' + slot.getAttribute('data-sum') + '"]', form), lang = slot.closest('[lang]').lang;
        var picked = field && (field.querySelector('input:checked + .c72-choice__t') || field.querySelector('option:checked'));
        if (!picked || !picked.value && picked.tagName === 'OPTION') return;
        slot.textContent = picked.tagName === 'OPTION' ? picked.getAttribute('data-' + lang) || picked.textContent : textIn(picked, lang);
        filled++;
      }, done);
      each('[data-sum-line]', function (e) { e.hidden = filled === 0; }, done);      // строка сводки скрыта, пока в ней нечего показать
      each('[data-form-body]', function (e) { e.hidden = true; }, form);
      done.hidden = false;
      each('[data-list-item]', function (i) { i.hidden = true; }, form);      // список очищается после отправки
      fire('c72:quote-list-change');
      done.focus();
      window.scrollTo(0, 0);
    };
    form.report = report;
  }
})();

/* Текстовые страницы (окно 4f): оглавление из заголовков h2 блоков [data-prose] и отметка текущего раздела.
   В теме — часть assets/c72-pages-ui.js. Оглавление показывается, если в тексте два раздела и больше;
   на широком экране блок раскрыт и липкий, на узком — свёрнут над текстом и закрывается после выбора пункта. */
(function () {
  var nav = document.querySelector('[data-toc]');
  var prose = document.querySelector('[data-prose]');
  if (!nav || !prose) return;
  var list = nav.querySelector('[data-toc-list]');
  var box = nav.querySelector('[data-toc-box]');
  var wide = window.matchMedia('(min-width: 1001px)');
  var links = [];
  var watch = null;

  function visible(el) { return el.getClientRects().length > 0; }   // второй язык макета скрыт: его заголовки не берём

  function build() {
    list.textContent = '';
    links = [];
    Array.prototype.forEach.call(prose.querySelectorAll('section[id]:not([data-toc-skip]) > h2'), function (h) {
      if (!visible(h)) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.parentNode.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, sec: h.parentNode });
    });
    nav.hidden = links.length < 2;
    nav.parentNode.classList.toggle('is-solo', nav.hidden);
    if (box) box.open = wide.matches;
    spy();
  }

  function mark(sec) {
    links.forEach(function (l) {
      if (l.sec === sec) l.a.setAttribute('aria-current', 'location');
      else l.a.removeAttribute('aria-current');
    });
  }

  function spy() {
    if (watch) watch.disconnect();
    if (!('IntersectionObserver' in window) || !links.length) return;
    watch = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) mark(en.target); });
    }, { rootMargin: '-30% 0px -60% 0px' });
    links.forEach(function (l) { watch.observe(l.sec); });
  }

  list.addEventListener('click', function (ev) {
    var a = ev.target.closest('a');
    if (!a) return;
    if (box && !wide.matches) box.open = false;   // на телефоне меню не закрывает текст после перехода
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (target) {
      target.setAttribute('tabindex', '-1');
      setTimeout(function () { target.focus({ preventScroll: true }); }, 0);
    }
  });
  if (wide.addEventListener) wide.addEventListener('change', function () { if (box) box.open = wide.matches; });
  document.addEventListener('c72:lang', build);   // только макет: язык меняется без перезагрузки
  build();
})();

/* FAQ: адрес #qN или #groupe-N открывает нужный вопрос (в теме — часть assets/c72-pages-ui.js, только при [data-faq]). */
(function () {
  if (!document.querySelector('[data-faq]')) return;
  function openTarget() {
    var id = decodeURIComponent(location.hash.slice(1));
    var el = id && document.getElementById(id);
    var box = el && el.closest('details');
    if (box) box.open = true;
  }
  window.addEventListener('hashchange', openTarget);
  openTarget();
})();
